import { render, staticRenderFns } from "./arch.vue?vue&type=template&id=0b2b331a&scoped=true"
import script from "./arch.vue?vue&type=script&lang=js"
export * from "./arch.vue?vue&type=script&lang=js"
import style0 from "./arch.vue?vue&type=style&index=0&id=0b2b331a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2b331a",
  null
  
)

export default component.exports